import cloneDeep from 'lodash-es/cloneDeep'
import set from 'lodash-es/set'
import some from 'lodash-es/some'
import React from 'react'
import { useParams } from 'react-router-dom'

import { WeightInput, useDashboardPermissions } from '@components'
import { Fieldset } from '@fourthwall/components'
import { useFormikContext } from '@fourthwall/utils/dist/formik'

import { useShopShippingFlatRatesQuery } from '../../../../../../hooks/useShopShippingFlatRatesQuery'
import { getFulfillmentType } from '../../../../../Product.utils'
import { useOfferQuery } from '../../../../../hooks'
import type { ProductFormState } from '../../../../SingleProduct.types'
import * as S from '../../ProductShippingByCreator/styled'

export const ShipmentWeightField = () => {
  const { hasPermission } = useDashboardPermissions()

  const { values, setFieldValue } = useFormikContext<ProductFormState>()
  const { variants } = values
  const isFormEditable = hasPermission('products.edit.details')
  const disabled = !isFormEditable

  const { productId = '' } = useParams<'productId'>()
  const { offerQuery } = useOfferQuery([productId])
  const variantTypes = offerQuery?.data?.variantTypes || []

  const hasDefinedWeight = offerQuery?.data?.productId !== null
  const fulfillmentType = getFulfillmentType(values.fulfillmentService)

  const { shopShippingFlatRatesQuery } = useShopShippingFlatRatesQuery()
  const areFlatRatesEnabled = Boolean(shopShippingFlatRatesQuery.data?.enabled)

  const weightMayVary = some(variantTypes, { variesBy: { weight: true } })

  const handleWeightValueChange = async (value: string) => {
    await setFieldValue(
      'variants',
      cloneDeep(variants).map((variant) => set(variant, 'weight.value', value)),
    )
  }

  const handleUnitValueChange = async (value: string) => {
    await setFieldValue(
      'variants',
      cloneDeep(variants).map((variant) => set(variant, 'weight.unit', value)),
    )
  }

  if (fulfillmentType === 'DIGITAL') {
    return null
  }

  return (
    !weightMayVary &&
    !hasDefinedWeight &&
    (!areFlatRatesEnabled || fulfillmentType !== 'FULFILLED_BY_CREATOR') && (
      <Fieldset.Row>
        <S.WeightInputContainer>
          <WeightInput
            weightName="variants[0].weight.value"
            unitName="variants[0].weight.unit"
            disabled={disabled}
            onWeightValueChange={handleWeightValueChange}
            onUnitValueChange={handleUnitValueChange}
          />
        </S.WeightInputContainer>
      </Fieldset.Row>
    )
  )
}
